import * as React from 'react';

const SvgArrowSmallDownOutlined = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 25 25"
		width="1em"
		height="1em"
		{...props}
	>
		<path
			fill="#60636B"
			fillRule="evenodd"
			d="M6.65625 13.3625C6.36298 13.07 5.8881 13.0706 5.59559 13.3639C5.30308 13.6572 5.3037 14.1321 5.59698 14.4246L12.6061 21.4154C12.8994 21.708 13.3742 21.7073 13.6668 21.4141L20.6576 14.4049C20.9501 14.1117 20.9495 13.6368 20.6562 13.3443C20.363 13.0518 19.8881 13.0524 19.5956 13.3457L14.0539 18.9019C13.9909 18.9649 13.8832 18.9205 13.8831 18.8314L13.8642 4.38346C13.8637 3.96925 13.5275 3.6339 13.1132 3.63444C12.699 3.63498 12.3637 3.97121 12.3642 4.38542L12.3831 18.8333C12.3832 18.9224 12.2755 18.9672 12.2124 18.9043L6.65625 13.3625Z"
			clipRule="evenodd"
		/>
	</svg>
);
export default SvgArrowSmallDownOutlined;
